
const imagesArray = [
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0066.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0067.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0068.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0069.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0070.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0071.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0072.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0073.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0074.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0075.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0076.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0077.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0078.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0079.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0080.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0081.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0082.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0083.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0084.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0085.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0086.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0087.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0088.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0089.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0090.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0091.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0092.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0093.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0094.png.jpg"),
  require("../assets/sprites-fashion/LS_3DSprite_ShouShou.0095.png.jpg")
]

export {
  imagesArray
};